import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, IPolicyEligibleServicesDto } from '@/dtos';

export interface PolicyEligibleService {
  policyId?: string;
  categories?: string[];
}

interface Props {
  policyIds?: string[];
}

const useGetPolicyServicesQuery = ({ policyIds }: Props) => {
  const { data, isLoading } = useQuery([API_URL.PLANS_SERVICES, policyIds], () =>
    api.get<IPolicyEligibleServicesDto[]>(API_URL.PLANS_SERVICES, {
      params: {
        policy_ids: policyIds || undefined,
      },
    }),
    {
      enabled: !!policyIds?.length,
    }
  );

  const policyEligibleServices = useMemo(() => {
    if (!data?.data?.length) {
      return [];
    }

    return data?.data?.map((servicesCategory): PolicyEligibleService => ({
      policyId: toString(servicesCategory?.policy_id),
      categories: servicesCategory?.categories?.map((category) => category?.category)?.filter(Boolean) as string[] || [],
    }));
  }, [data?.data]);

  return {
    policyEligibleServices,
    isPolicyServicesLoading: isLoading,
  };
};

export default useGetPolicyServicesQuery;
